export function isXmlFile(filename: string): boolean {
  return filename.toLowerCase().endsWith('.xml');
}
